import { AllRoutes } from 'constants/routes';
import { NavLink, Outlet } from 'react-router-dom';
import styles from './Accounts.module.scss';
import {getPack, getPdf} from "../../utils/getPdf";

export const Accounts = () => {
    const loadPack = (year) => {
        const url = `/pack/${year}`;
        getPack(url, `${year}-facturas.zip`);
    };

  return (
    <>
      <div className={styles.tabs}>
        <NavLink className={({ isActive }) => (isActive ? styles.activeLink : '')} to={AllRoutes.home}>
          Albaran
        </NavLink>
        <NavLink className={({ isActive }) => (isActive ? styles.activeLink : '')} to={AllRoutes.facturas}>
          Factura
        </NavLink>
        {/*<NavLink onClick={(e) => {*/}
        {/*    e.stopPropagation();*/}
        {/*    loadPack(2023);*/}
        {/*}}>*/}
        {/*  2023*/}
        {/*</NavLink>*/}
      </div>
      <Outlet />
    </>
  );
};
